var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5532 6.12692L12.7756 6.07722L12.7969 3.56372",
    stroke: "#8F96A9",
    strokeWidth: 1.25,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37727 10.0391L3.22589 10.0817L3.20459 12.2614",
    stroke: "#8F96A9",
    strokeWidth: 1.25,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08398 8.22144C3.08363 7.10668 3.45437 6.0235 4.13769 5.14274C4.82102 4.26197 5.77808 3.63371 6.85795 3.35703C7.93783 3.08035 9.07907 3.17099 10.1017 3.61465C11.1244 4.05831 11.9703 4.82977 12.5061 5.80735",
    stroke: "#8F96A9",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9319 8.17163C12.9328 9.25056 12.5744 10.2991 11.9133 11.1517C11.2522 12.0044 10.3259 12.6126 9.28076 12.8804C8.23559 13.1482 7.13099 13.0603 6.1413 12.6307C5.15161 12.201 3.99313 11.0874 3.4751 10.1409",
    stroke: "#8F96A9",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReload);
export default __webpack_public_path__ + "static/media/ic_reload.5bdae25a8528e06fef1271dbb2bc440d.svg";
export { ForwardRef as ReactComponent };